import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import BioPage from "./pages/BioPage";
import Gallery from "./pages/Gallery";
import Tarif from "./pages/Tarif";
import Contact from "./pages/Contact";
import SportPage from "./pages/SportPage";
import ConcertPage from "./pages/ConcertPage";
import MariagePage from "./pages/MariagePage";
import PortraitPage from "./pages/PortraitPage";
import ShootingPage from "./pages/ShootingPage";
import ExterieurPage from "./pages/ExterieurPage";
import PaysagePage from "./pages/PaysagePage";
import AddPhotos from "./pages/AddPhotos";
import AdminContextProvider from "./context/AdminContext";
import FormUserConnection from "./components/FormUserConnection";

// Import de TanStack Query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RgpdPage from "./pages/RgpdPage";
import SortiesPhoto from "./pages/SortiesPhoto";
import AteliersPage from "./pages/AteliersPage";
import SortiesThematiquesPage from "./pages/SortiesThematiquesPage";
import ParcoursLyonPage from "./pages/ParcoursLyonPage";

// Créer une instance de QueryClient
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
  <AdminContextProvider>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bio" element={<BioPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/prestation" element={<Tarif />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/rgpd" element={<RgpdPage />} />
          <Route path="/add-photos" element={<AddPhotos />} />
          <Route path="/admin-connection" element={<FormUserConnection />} />
          <Route path="/gallery/sport/:id" element={<SportPage />} />
          <Route path="/gallery/concert/:id" element={<ConcertPage />} />
          <Route path="/gallery/mariage/:id" element={<MariagePage />} />
          <Route path="/gallery/portrait/:id" element={<PortraitPage />} />
          <Route path="/gallery/shooting/:id" element={<ShootingPage />} />
          <Route path="/gallery/exterieur/:id" element={<ExterieurPage />} />
          <Route path="/gallery/paysage/:id" element={<PaysagePage />} />
          <Route path="/sorties-photo" element={<SortiesPhoto />} />
          {process.env.REACT_APP_ATELIERS_ENABLED === "true" && (
            <Route path="/ateliers" element={<AteliersPage />} />
          )}
          {process.env.REACT_APP_SORTIES_THEMATIQUES_ENABLED === "true" && (
            <Route path="/sorties-thematiques" element={<SortiesThematiquesPage />} />
          )}
          {process.env.REACT_APP_PARCOURS_ENABLED === "true" && (
            <Route path="/parcours-lyon" element={<ParcoursLyonPage />} />
          )}
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </AdminContextProvider>
  </HelmetProvider>,
);
